import { AdminPage } from '@wanjianshi/admin-ui';
import { Tabs } from '@wanjianshi/admin-ui';
import { useParams } from 'react-router-dom';
import { ResourceListPage } from './ResourceListPage';

export function CanvasDetailPage() {
  const { projectId, graphId } = useParams();
  const base = `/admin/projects/${projectId}/canvases/${graphId}`;
  return (
    <AdminPage title={`画布 #${graphId}`} description={`项目 #${projectId} / 画布 #${graphId}`}>
      <Tabs items={[
        { key: 'nodes', label: '节点', children: <ResourceListPage title="节点" endpoint={`${base}/nodes`} fields={['id', 'node_id', 'type', 'title', 'status', 'update_time']} /> },
        { key: 'connections', label: '连线', children: <ResourceListPage title="连线" endpoint={`${base}/connections`} /> },
        { key: 'groups', label: '分组', children: <ResourceListPage title="分组" endpoint={`${base}/groups`} /> },
        { key: 'snapshots', label: '快照', children: <ResourceListPage title="快照" endpoint={`${base}/snapshots`} /> },
      ]} />
    </AdminPage>
  );
}
